export * from './utils';
import { processFormGroups, processUngroupedFields } from './formGroupProcessors';

/**
 * Form Field Groups Mapping
 * @param {Object} config
 * @param {Number} operationType
 * @returns Object
 */
export default function formFieldGroupsMapping(config, operationType) {
  const { form } = config || {};
  const formId = form?.id;

  if (!form?.groups) {
    return { formId, groups: [] };
  }

  const groupsData = processFormGroups(form, config, formId, operationType);
  const ungroupedFields = processUngroupedFields(config, formId, operationType);

  const finalGroups = ungroupedFields ? [ungroupedFields, ...groupsData] : groupsData;

  return { formId, groups: finalGroups };
}
